import React, { useMemo, useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Building2,
  CreditCard,
  LayoutGrid,
  FlaskConical,
  Mail,
  MessageCircle,
  MessageSquareWarning,
  Receipt,
  ScanLine,
  ScrollText,
} from "lucide-react";
import { ENTERPRISE_CONTROL_BASE } from "../enterprise-control/constants";
import PortalSidebar from "../admin-shared/PortalSidebar";
import { confirmAndLogout } from "../utils/auth";
import nyafazLogo from "../../salon-admin/assets/nyafazlogo.png";

const PortalHeadSidebar = ({ expanded, setExpanded }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [viewport, setViewport] = useState("desktop");

  useEffect(() => {
    const update = () => {
      const w = window.innerWidth;
      if (w < 768) setViewport("mobile");
      else if (w < 1367) setViewport("tablet");
      else setViewport("desktop");
    };
    update();
    window.addEventListener("resize", update);
    return () => window.removeEventListener("resize", update);
  }, []);

  const sidebarPath =
    location.pathname.startsWith("/enterprise-portal/products/salon") ||
    location.pathname.startsWith("/enterprise-portal/products/brand")
      ? "/enterprise-portal/home"
      : location.pathname === ENTERPRISE_CONTROL_BASE ||
          location.pathname.startsWith(`${ENTERPRISE_CONTROL_BASE}/`)
        ? "/enterprise-portal/home"
        : location.pathname;

  const menuItems = useMemo(() => {
    const items = [
      {
        key: "portal-home",
        sectionId: "overview",
        IconComponent: LayoutGrid,
        label: "Overview",
        to: "/enterprise-portal/home",
      },
      {
        key: "portal-orgs",
        sectionId: "organization",
        IconComponent: Building2,
        label: "All organizations",
        to: "/enterprise-portal/organizations",
      },
      {
        key: "portal-plans",
        sectionId: "organization",
        IconComponent: CreditCard,
        label: "Plan management",
        to: "/enterprise-portal/plans",
      },
      {
        key: "portal-scans",
        sectionId: "organization",
        IconComponent: ScanLine,
        label: "Plan limits",
        to: "/enterprise-portal/scan-limits",
      },
      {
        key: "portal-notices",
        sectionId: "organization",
        IconComponent: Mail,
        label: "Billing emails",
        to: "/enterprise-portal/billing-emails",
      },
      {
        key: "portal-invoice-profile",
        sectionId: "organization",
        IconComponent: Receipt,
        label: "Invoice profile",
        to: "/enterprise-portal/invoice-profile",
      },
      {
        key: "portal-billing-test",
        sectionId: "organization",
        IconComponent: FlaskConical,
        label: "Billing test",
        to: "/enterprise-portal/billing-test",
      },
      {
        key: "portal-analysis-whatsapp",
        sectionId: "organization",
        IconComponent: MessageCircle,
        label: "Analysis WhatsApp",
        to: "/enterprise-portal/analysis-whatsapp",
      },
    ];

    items.push(
      {
        key: "escalated",
        sectionId: "about",
        IconComponent: MessageSquareWarning,
        label: "Escalated support",
        to: "/enterprise-portal/escalated-complaints",
      },
      {
        key: "plan-requests",
        sectionId: "about",
        IconComponent: MessageSquareWarning,
        label: "Plan requests",
        to: "/enterprise-portal/plan-requests",
      },
      {
        key: "release-notes",
        sectionId: "about",
        IconComponent: ScrollText,
        label: "Release notes",
        to: "/enterprise-portal/release-notes",
      },
    );

    return items;
  }, []);

  const isCompactViewport = viewport === "tablet" || viewport === "mobile";

  return (
    <PortalSidebar
      menuItems={menuItems}
      releaseNotesPath="/enterprise-portal/release-notes"
      logoSrc={nyafazLogo}
      logoFallback={nyafazLogo}
      expanded={expanded}
      setExpanded={setExpanded}
      onLogout={() => confirmAndLogout(navigate)}
      isCompactViewport={isCompactViewport}
      locationPathname={sidebarPath}
    />
  );
};

export default PortalHeadSidebar;
